<template>
  <v-dialog :value="value" max-width="600px" persistent @input="$emit('input', $event)">
    <v-card v-if="value">
      <v-card-title class="headline d-flex align-center">
        Penerima email
        <v-chip small dark :color="bandColor(meta.band)" class="ml-3">{{ meta.title }}</v-chip>
      </v-card-title>
      <v-card-text class="pb-0">
        <div class="bm-tiny mb-5">
          Dikirim {{ meta.when }}. Placeholder diganti orangnya saat kirim; alamat yang tidak bisa
          dipetakan dilewati.
        </div>

        <v-combobox
          v-model="to"
          :items="placeholders"
          label="Kepada"
          multiple
          chips
          deletable-chips
          small-chips
          outlined
          dense
          hint="Ketik email lalu Enter, atau pilih placeholder."
          persistent-hint
          :delimiters="[',', ' ', ';']"
          class="mb-4"
        >
          <template v-slot:selection="{ item, parent }">
            <v-chip
              small
              :color="isPlaceholder(item) ? 'blue lighten-5' : 'grey lighten-3'"
              :class="isPlaceholder(item) ? 'blue--text text--darken-2 bm-mono' : ''"
              close
              @click:close="parent.selectItem(item)"
              >{{ item }}</v-chip
            >
          </template>
          <template v-slot:item="{ item }">
            <span class="bm-mono blue--text text--darken-2 mr-2">{{ item }}</span>
            <span class="bm-tiny">{{ placeholderHelp[item] }}</span>
          </template>
        </v-combobox>

        <v-combobox
          v-model="cc"
          :items="placeholders"
          label="CC"
          multiple
          chips
          deletable-chips
          small-chips
          outlined
          dense
          hint="Opsional."
          persistent-hint
          :delimiters="[',', ' ', ';']"
          class="mb-4"
        >
          <template v-slot:selection="{ item, parent }">
            <v-chip
              small
              :color="isPlaceholder(item) ? 'blue lighten-5' : 'grey lighten-3'"
              :class="isPlaceholder(item) ? 'blue--text text--darken-2 bm-mono' : ''"
              close
              @click:close="parent.selectItem(item)"
              >{{ item }}</v-chip
            >
          </template>
          <template v-slot:item="{ item }">
            <span class="bm-mono blue--text text--darken-2 mr-2">{{ item }}</span>
            <span class="bm-tiny">{{ placeholderHelp[item] }}</span>
          </template>
        </v-combobox>

        <v-alert v-if="!to.length" type="info" text dense class="mb-3">
          Tanpa penerima, perpindahan band {{ meta.title.toLowerCase() }} tetap dicatat tapi tidak
          ada email (nonaktif).
        </v-alert>
        <div v-if="invalid.length" class="error--text bm-tiny mb-3">
          Bukan email / placeholder: {{ invalid.join(", ") }}
        </div>
      </v-card-text>
      <v-card-actions class="px-4 pb-3">
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('input', false)">Batal</v-btn>
        <v-btn color="primary" :loading="saving" :disabled="invalid.length > 0" @click="save"
          >Simpan</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  NOTIFICATION_TYPE_META,
  PLACEHOLDER_HELP,
  RECIPIENT_PLACEHOLDERS,
  bandColor,
  isPlaceholder,
} from "@/utils/budgetMonitor";

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** Recipients (TO / CC) of one notification type; placeholders resolve to people when the mail is sent. */
export default {
  name: "budget-recipient-dialog",
  props: {
    value: Boolean,
    /** BUDGET_YELLOW | BUDGET_RED | BUDGET_RECOVERED */
    notificationType: { type: String, required: true },
    /** current RecipientDto[] ({ recipientType: TO|CC, email }) */
    recipients: { type: Array, default: () => [] },
  },
  data: () => ({
    to: [],
    cc: [],
    saving: false,
    placeholders: RECIPIENT_PLACEHOLDERS,
    placeholderHelp: PLACEHOLDER_HELP,
  }),
  computed: {
    meta() {
      return (
        NOTIFICATION_TYPE_META[this.notificationType] || {
          band: "NO_BUDGET",
          title: this.notificationType,
          when: "",
        }
      );
    },
    invalid() {
      return [...this.to, ...this.cc].filter(
        e => !isPlaceholder(e) && !EMAIL.test(String(e).trim())
      );
    },
  },
  watch: {
    value(v) {
      if (v) {
        this.to = this.recipients.filter(r => r.recipientType !== "CC").map(r => r.email);
        this.cc = this.recipients.filter(r => r.recipientType === "CC").map(r => r.email);
      }
    },
  },
  methods: {
    bandColor,
    isPlaceholder,
    async save() {
      this.saving = true;
      try {
        const rows = [
          ...this.to.map(e => ({ recipientType: "TO", email: String(e).trim() })),
          ...this.cc.map(e => ({ recipientType: "CC", email: String(e).trim() })),
        ].filter(r => r.email);
        await this.$store.dispatch("budgetMonitor/saveRecipients", {
          notificationType: this.notificationType,
          recipients: rows,
        });
        this.$store.dispatch("toast", {
          type: "success",
          message: `Penerima ${this.meta.title} tersimpan (${rows.length}).`,
        });
        this.$emit("saved");
        this.$emit("input", false);
      } catch (e) {
        this.$store.dispatch("toast", { type: "error", message: "Gagal menyimpan penerima" });
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
